import Footer from './components/Footer/Footer';
import NotFound from './pages/NotFound/NotFound';
import Accessibility from './pages/Accessibility/Accessibility';
import Home from './pages/Home/Home';
import Confidentiality from './pages/Confidentiality/Confidentiality';
import SiteMap from './pages/SiteMap/SiteMap';
import AdminPanel from './pages/AdminPanel/AdminPanel';
import Header from './components/Header/Header';
import { APP_ROUTES } from './utils/constants';

import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';


function App() {

  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route index element={<Home />} />
          <Route path={APP_ROUTES.ACCESSIBILITY} element={<Accessibility />} />
          <Route path={APP_ROUTES.CONFIDENTIALITY} element={<Confidentiality />} />
          <Route path={APP_ROUTES.SITEMAP} element={<SiteMap />} />
          <Route path={APP_ROUTES.ADMIN_PANEL} element={<AdminPanel />} />
          <Route path ="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
